import { z } from "zod";

// Skema untuk satu kamar di dalam array 'booking'
const BookingRoomDataSchema = z.object({
    id: z.string().uuid(),
    reservation_id: z.string().uuid(),
    // Nullable: booking dari Channex yang belum di-mapping bisa belum punya room_type_id
    room_type_id: z.string().uuid().nullable(),
    room_id: z.string().uuid().nullable(),
    agent_id: z.string().uuid().nullable(),
    agent: z.nullable(z.object({
        id: z.string().uuid(),
        name: z.string(),
    })).optional(),
    rate_plan_id: z.nullable(z.string().uuid()),
    checkin_date: z.string(),
    checkout_date: z.string(),
    adults: z.number(),
    children: z.number(),
    // Nullable: booking Channex unmapped bisa belum punya status yang jelas
    status: z.string().nullable(),
    mark: z.string().nullable(),
    invoice_number: z.string(),
    invoice_date: z.string(),
    public_note: z.string().nullable(),
    private_note: z.string().nullable(),
    customer_name: z.string(),
    customer_surname: z.string().nullable(),
    customer_email: z.nullable(z.string()),
    customer_phone: z.string().nullable(),
    customer_address: z.string().nullable(),
    customer_country: z.string().nullable(),
    customer_state: z.string().nullable(),
    customer_city: z.string().nullable(),
    customer_zip: z.string().nullable(),
    customer_date_of_birth: z.string().nullable(),
    customer_identity_number: z.string().nullable(),
    payment_type: z.nullable(z.string()),
    total_rate: z.string(), // Diterima sebagai string
    total_payment: z.coerce.number(),
    total_surcharge: z.coerce.number(),
    due_payment: z.string(), // Diterima sebagai string
    rates: z.array(z.object({
        id: z.number(),
        date: z.string(),
        rate: z.string(), // Diterima sebagai string
    })),
    payments: z.array(z.object({
        id: z.string().uuid(),
        date_payment: z.string(),
        payment_type: z.string(),
        amount: z.string(), // Diterima sebagai string
        surcharge: z.string(), // Diterima sebagai string
    })),
    // Relasi (opsional karena tergantung `include`)
    // Nullable + optional: booking Channex unmapped bisa belum punya relasi roomType
    roomType: z.object({ id: z.string(), name: z.string() }).nullable().optional(),
    room: z.object({ id: z.string(), room_number: z.string() }).optional().nullable(),
    ratePlan: z.nullable(z.object({ id: z.string(), name: z.string() })).optional(),
    ota_name: z.nullable(z.string()).optional(),
    voucher_number: z.nullable(z.string()).optional(),
    // Penanda segmen split, dipakai layar edit reservasi untuk menampilkan tombol Merge.
    // Optional supaya tidak pecah kalau API belum ter-deploy.
    split_date: z.nullable(z.string()).optional(),
    parent_booking_room_id: z.nullable(z.string()).optional(),
    split_role: z.enum(['segment_1', 'segment_2']).nullable().optional(),
});

// Skema untuk objek 'data' utama
const ShowBookingDataSchema = z.object({
    id: z.string().uuid(),
    property_id: z.string().uuid(),
    source: z.string(),
    booking: z.array(BookingRoomDataSchema),
    property: z.object({
        id: z.string().uuid(),
        name: z.string(),
        logo_url: z.nullable(z.string().url()).optional(),
        logo: z.nullable(z.string()).optional(),
        property_type: z.string().optional(),
    }).optional(),
});

// Skema utama untuk seluruh respons API
export const ShowBookingResponseV4Schema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: ShowBookingDataSchema,
});

export type ShowBookingResponseV4 = z.infer<typeof ShowBookingResponseV4Schema>;
export type ShowBookingDataV4 = z.infer<typeof ShowBookingDataSchema>;
export type BookingRoomDataV4 = z.infer<typeof BookingRoomDataSchema>;